module.exports = __webpack_public_path__ + "img/produm-mob.8a7f2703.png";